export default {"src":"/_next/static/media/socials-google.1776a9e5.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};